const resources = {
    forYou: 'Pour vous'
};

module.exports = function getResource(label) {
    return resources[label];
};
